import { BillingFrequencyType, BILLING_FREQUENCY_DB } from '@/const/shared';
import {
  CoveringBlock,
  DiscountBadge,
  FrequencyButton,
  FrequencyToggleWrapper,
  ToggleWrapper,
} from '@/bundle/Auth/AdminOnboardingFlow/SelectBillingPlanPage/ui/BillingFrequencyToggle/styles';
import { isMonthlyFrequency, isYearlyFrequency } from '@/helpers/billingHelpers';

type BillingFrequencyToggleType = {
  frequency: BillingFrequencyType;
  onChange: (frequency: BillingFrequencyType) => void;
};

export const BillingFrequencyToggle = ({ frequency, onChange }: BillingFrequencyToggleType) => {
  const monthlyFrequency = isMonthlyFrequency(frequency);
  const yearlyFrequency = isYearlyFrequency(frequency);

  const setMonthlyFrequency = () => onChange(BILLING_FREQUENCY_DB.MONTH);
  const setYearlyFrequency = () => onChange(BILLING_FREQUENCY_DB.YEAR);

  return (
    <FrequencyToggleWrapper>
      <ToggleWrapper>
        <CoveringBlock frequency={frequency} />
        <FrequencyButton onClick={setMonthlyFrequency} active={monthlyFrequency}>
          Monthly
        </FrequencyButton>
        <FrequencyButton onClick={setYearlyFrequency} active={yearlyFrequency}>
          Yearly
          <DiscountBadge>Save 10%</DiscountBadge>
        </FrequencyButton>
      </ToggleWrapper>
    </FrequencyToggleWrapper>
  );
};
